import React from 'react';
import { Box, Button, Divider, IconButton, Stack, TextField, Typography, Drawer } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import { XCircle } from 'lucide-react';

const BookingFilterDrawer = ({
  open,
  onClose,
  filters,
  onInputChange,
  onDateChange,
  onClearFilters,
  onApplyFilters,
}) => (
  <Drawer anchor="right" open={open} onClose={onClose}>
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box
        sx={{
          width: { xs: '70vw', sm: '70vw', md: 400 },
          maxHeight: '100vh',
          overflowY: 'auto',
          p: 2,
        }}
        role="presentation"
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
          <Typography variant="h6" gutterBottom>
            Filter Bookings
          </Typography>
          <IconButton onClick={onClose} size="small">
            <XCircle />
          </IconButton>
        </Box>

        <Divider sx={{ mb: 2 }} />

        <Stack spacing={2}>
          <TextField
            label="Guest Name"
            fullWidth
            size="small"
            value={filters?.guestName}
            onChange={onInputChange('guestName')}
          />
          <TextField
            label="BnB Short Name"
            fullWidth
            size="small"
            value={filters?.bnbShortName}
            onChange={onInputChange('bnbShortName')}
          />
          <TextField
            label="Booking Code"
            fullWidth
            size="small"
            value={filters?.bookingCode}
            onChange={onInputChange('bookingCode')}
          />
          <TextField
            label="Booking ID"
            fullWidth
            size="small"
            value={filters?.bookingId}
            onChange={onInputChange('bookingId')}
          />
          <DatePicker
            label="Check-In Date"
            value={filters?.checkInDate}
            onChange={onDateChange('checkInDate')}
            slotProps={{
              textField: { fullWidth: true, size: 'small', sx: { width: '100%' } },
              actionBar: { actions: ['clear', 'accept'] },
              popper: {
                modifiers: [
                  {
                    name: 'preventOverflow',
                    options: { boundary: 'window' },
                  },
                ],
              },
            }}
          />
          <DatePicker
            label="Check-Out Date"
            value={filters?.checkOutDate}
            onChange={onDateChange('checkOutDate')}
            slotProps={{
              textField: { fullWidth: true, size: 'small', sx: { width: '100%' } },
              actionBar: { actions: ['clear', 'accept'] },
              popper: {
                modifiers: [
                  {
                    name: 'preventOverflow',
                    options: { boundary: 'window' },
                  },
                ],
              },
            }}
          />
          <TimePicker
            label="Check-In Time"
            value={filters?.checkInTime}
            onChange={onDateChange('checkInTime')}
            ampm={false}
            slotProps={{
              textField: { fullWidth: true, size: 'small', sx: { width: '100%' } },
              actionBar: { actions: ['clear', 'accept'] },
            }}
          />
          <TimePicker
            label="Check-Out Time"
            value={filters?.checkOutTime}
            onChange={onDateChange('checkOutTime')}
            ampm={false}
            slotProps={{
              textField: { fullWidth: true, size: 'small', sx: { width: '100%' } },
              actionBar: { actions: ['clear', 'accept'] },
            }}
          />
          <TextField
            label="Check-In Status"
            fullWidth
            size="small"
            value={filters?.checkInStatus}
            onChange={onInputChange('checkInStatus')}
          />
        </Stack>

        {/* <Box mt={3}></Box> */}
        <Box mt={1}>
          <Button variant="contained" color="primary" fullWidth sx={{ mb: 1 }} onClick={onApplyFilters}>
            Apply Filters
          </Button>
          <Button variant="outlined" color="secondary" fullWidth onClick={onClearFilters}>
            Clear Filters
          </Button>
        </Box>
      </Box>
    </LocalizationProvider>
  </Drawer>
);

export default BookingFilterDrawer;
